import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { OfflineFallback } from "@/components/OfflineFallback";
import { UpdateToast } from "@/components/UpdateToast";
import SplashScreen from "@/screens/SplashScreen";
import LoginScreen from "@/screens/LoginScreen";
import SignupScreen from "@/screens/SignupScreen";
import LegalScreen from "@/screens/LegalScreen";
import OnboardingPersonalScreen from "@/screens/OnboardingPersonalScreen";
import OnboardingVerificationScreen from "@/screens/OnboardingVerificationScreen";
import CreateProjectScreen from "@/screens/CreateProjectScreen";
import DashboardScreen from "@/screens/DashboardScreen";
import ScannerScreen from "@/screens/ScannerScreen";
import MaterialTakeoffScreen from "@/screens/MaterialTakeoffScreen";
import GreenIntelligenceScreen from "@/screens/GreenIntelligenceScreen";
import CostAnalyticsScreen from "@/screens/CostAnalyticsScreen";
import ComplianceChecklistScreen from "@/screens/ComplianceChecklistScreen";
import SettingsScreen from "@/screens/SettingsScreen";
import BillingScreen from "@/screens/BillingScreen";

function App() {
  return (
    <BrowserRouter>
      <OfflineFallback />
      <UpdateToast />
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/signup" element={<SignupScreen />} />
        <Route path="/onboarding/personal" element={<OnboardingPersonalScreen />} />
        <Route path="/onboarding/verification" element={<OnboardingVerificationScreen />} />
        <Route path="/projects/new" element={<CreateProjectScreen />} />
        <Route path="/dashboard" element={<DashboardScreen />} />
        <Route path="/scan" element={<ScannerScreen />} />
        <Route path="/materials" element={<MaterialTakeoffScreen />} />
        <Route path="/green" element={<GreenIntelligenceScreen />} />
        <Route path="/costs" element={<CostAnalyticsScreen />} />
        <Route path="/compliance" element={<ComplianceChecklistScreen />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/billing" element={<BillingScreen />} />
        <Route path="/home" element={<Navigate to="/dashboard" replace />} />
        <Route path="/legal/terms" element={<LegalScreen kind="terms" />} />
        <Route path="/legal/privacy" element={<LegalScreen kind="privacy" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
